__turbopack_context__.v({
  "canvas": "mochi-sparkles-module-scss-module__2za56W__canvas",
});
